import {defineStore} from 'pinia'
import {useSummaryStats} from '~/composables/api/useSummaryApi'
import type {AppStatisticsItem} from '~/types/types'

export const useAppStatStore = defineStore('appStat', () => {
  const {getSummaryStats} = useSummaryStats()
  const {session} = useAuth()

  // State
  const brandCount = ref(0)
  const cityCount = ref(0)
  const dayCount = ref(0)
  const locationCount = ref(0)
  const productCount = ref(0)
  const regionCount = ref(0)
  const retailerCount = ref(0)
  const loading = ref(true)
  const Loaded = ref(false)

  // Actions
  async function fetchStats() {
    loading.value = true
    try {
      if (!session.value?.data) {
        loading.value = false
        return
      }

      const data = (await getSummaryStats()) as AppStatisticsItem

      brandCount.value = data.brandCount || 0
      cityCount.value = data.cityCount || 0
      dayCount.value = data.dayCount || 0
      locationCount.value = data.locationCount || 0
      productCount.value = data.productCount || 0
      regionCount.value = data.regionCount || 0
      retailerCount.value = data.retailerCount || 0
      Loaded.value = true
    } catch (error) {
      console.error('Failed to fetch stats:', error)
    } finally {
      loading.value = false
    }
  }

  // ========================================================
  // AUTOMATIC INITIALIZATION ZONE
  // ========================================================
  // run only on client side once Nuxt has mounted the app context
  if (import.meta.client) {
    // Watch for the session authentication validation to pass successfully
    watch(
      () => session.value?.data,
      (newSession) => {
        if (newSession && !Loaded.value) {
          fetchStats()
        }
      },
      {immediate: true} // Run immediately in case session is already cached
    )
  }

  return {
    brandCount,
    cityCount,
    dayCount,
    locationCount,
    productCount,
    regionCount,
    retailerCount,
    loading,
    Loaded,
    fetchStats
  }
})
